import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';

const ForgotPasswordPage = () => {
  const [formData, setFormData] = useState({
    contact: '',
    contactType: 'email'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleContactTypeChange = (type) => {
    setFormData({
      ...formData,
      contactType: type,
      contact: ''
    });
  };

  const resetForm = () => {
    setFormData({
      contact: '',
      contactType: 'email'
    });
  };

  const validateForm = () => {
    if (!formData.contact.trim()) {
      setError(`${formData.contactType === 'email' ? "L'email" : "Le numéro de téléphone"} est requis`);
      return false;
    }

    if (formData.contactType === 'email') {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(formData.contact)) {
        setError("Format d'email invalide");
        return false;
      }
    } else {
      const phoneRegex = /^\+229[0-9]{8,11}$/;
      if (!phoneRegex.test(formData.contact)) {
        setError("Format de téléphone invalide. Exemple: +22901XXXXXXXX");
        return false;
      }
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!validateForm()) return;

    setLoading(true);

    try {
      await api.post('/auth/forgot-password', {
        contact: formData.contact,
      });

      resetForm();

      if (formData.contactType === 'email') {
        setSuccess('Si un compte existe avec cette adresse, un email de réinitialisation vous sera envoyé sous peu.');
      } else {
        setSuccess('Si un compte existe avec ce numéro, un message Telegram contenant le lien de réinitialisation vous sera envoyé sous peu.');
      }

    } catch (err: any) {
      const detail = err.response?.data?.detail;
      setError(Array.isArray(detail) ? detail.map((e: any) => e.msg || JSON.stringify(e)).join(", ") : (typeof detail === "string" ? detail : err.message || "Une erreur est survenue. Veuillez réessayer."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-md mx-auto bg-white rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-slate mb-6 text-center">Mot de passe oublié</h1>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        {success && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
            {success}
          </div>
        )}

        <p className="text-slate mb-6">
          Entrez votre adresse email ou numéro de téléphone pour recevoir un lien de réinitialisation de votre mot de passe.
        </p>

        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-slate font-medium mb-2">
              Méthode de récupération
            </label>
            <div className="flex border border-gray-300 rounded-md overflow-hidden">
              <button
                type="button"
                className={`flex-1 py-2 px-4 ${formData.contactType === 'email' ? 'bg-olive text-white' : 'bg-gray-100'}`}
                onClick={() => handleContactTypeChange('email')}
              >
                Email
              </button>
              <button
                type="button"
                className={`flex-1 py-2 px-4 ${formData.contactType === 'phone' ? 'bg-olive text-white' : 'bg-gray-100'}`}
                onClick={() => handleContactTypeChange('phone')}
              >
                Téléphone
              </button>
            </div>
          </div>

          <div className="mb-6">
            <label className="block text-slate font-medium mb-2" htmlFor="contact">
              {formData.contactType === 'email' ? 'Email' : 'Téléphone (ex: +22901XXXXXXXX)'}
            </label>
            <input
              type={formData.contactType === 'email' ? 'email' : 'tel'}
              id="contact"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              placeholder={formData.contactType === 'email' ? 'votre@email.com' : '+22901XXXXXXXX'}
              required
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-terracotta"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-olive text-white py-2 px-4 rounded-md hover:bg-terracotta transition duration-300 disabled:opacity-50"
          >
            {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
          </button>
        </form>

        <div className="mt-6 text-center">
          <p className="text-slate">
            <Link to="/login" className="text-terracotta hover:underline">Retour à la connexion</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;